import cloneDeep from "lodash/cloneDeep";
import map from "lodash/map";
export default (graphComponentRef) => (documentObjectId, attributes) => {
    if (!graphComponentRef.current)
        return undefined;
    const node = graphComponentRef.current.graph.nodes.find(n => n.tag.Id === documentObjectId);
    if (!node || !node.tag)
        return undefined;
    const nodeTag = cloneDeep(node.tag);
    nodeTag.Attributes = map(attributes, (attr, ind) => ({ ...attr, Position: ind }));
    node.tag = nodeTag;
    return nodeTag;
};
